<template>
  <v-toolbar flat class="pl-2">
    <v-spacer></v-spacer>
    <!-- Botão de Atualizar -->
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="emitNewConnection" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      Nova conexão
    </v-tooltip>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn icon @click="refresh" v-on="on">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
      Atualizar Dados
    </v-tooltip>
  </v-toolbar>
</template>

<script>
export default {
  data() {
    return {
      query: {
        q: null
      }
    };
  },

  methods: {
    /**
     * Atualiza
     */
    async refresh() {
      try {
        await this.$nextTick();
        this.$loading.show();
        await this.$store.dispatch("financial_connections/refresh");
        this.$loading.hide();
      } catch (error) {
        this.$message.serverError(error);
        this.$loading.hide();
        console.log(error);
      }
    },

    emitNewConnection(){
      this.$emit('click:new')
    },

    onClear() {
      this.refresh();
    }
  }
};
</script>

<style>
</style>
